import axios from 'src/axios'
import { getURL} from 'src/utils/config';
import { handleResponse } from 'src/utils/responseHandler';

const getProtocolInfoActions = (protocol_id ,callback) => {
    axios({
        method: 'get',
        url: `${getURL('/protocols/protocol-actions')}?action_id=${protocol_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const addProtocolActions =(body,callback) =>{
    axios({
        method: 'post',
        url: getURL('/protocols/add-protocol-actions'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const addClientProtocolActions =(body,callback) =>{
    axios({
        method: 'post',
        url: getURL('/protocols/new-protocol-actions-request'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getProtocols = (callback) => {
    axios({
        method: 'get',
        url: `${getURL('/protocols/get-introsion-types')}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const addIntrusion =(body,callback) =>{
    axios({
        method: 'post',
        url: getURL('/protocols/add-introsion-type'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const addInstruction =(body,callback) =>{
    axios({
        method: 'post',
        url: getURL('/protocols/protocol-instructions'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const setAddProtocol = (body ,callback) => {
    axios({
        method: 'post',
        url: getURL('/protocols/add-introsion-type'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getClientInfo = (clientId ,callback) => {
    axios({
        method: 'get',
        url: `${getURL('/protocols/get-introsion-info')}?client_id=${clientId}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}



const setSaveProtocol = (body ,callback) => {
    axios({
        method: 'post',
        url: getURL('/protocols/add-introsion-contacts'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getProtocolsInfo = (params ,callback) => {
    const { intrusion_id, device_id } = params; 
    axios({
        method: 'get',
        url: `${getURL('/protocols/get-introsion-messages')}?intrusion_id=${intrusion_id}&device_id=${device_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getClientProtocolsInfoActions = ( params, callback) => {
    const { mapped_action_id } = params; 
    axios({
        method: 'get',
        url: `${getURL('/protocols/get-mapped-protocol-actions')}?mapped_action_id=${mapped_action_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const getInrusionInfo = (intrusion_id ,callback) => {
    axios({
        method: 'get',
        url: `${getURL('/protocols/get-protocols-info')}?intrusion_id=${intrusion_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getInstructionInfo = (intrusion_id ,callback) => {
    axios({
        method: 'get',
        url: `${getURL('/protocols/instructions')}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

// const addDevicesProtocol = (body ,callback) => {
//     axios({
//         method: 'post',
//         url: getURL('/protocols/add-introsion-message'),
//         data: body,
//         validateStatus: (status) => handleResponse(status)
//     }).then((response) => callback(response))
// }

const updateDeviceProtocolsInfo = (params ,callback) => {
   // console.log(params.id)
    axios({
        method: 'put',
        url: `${getURL('/protocols/update-introsion-message')}`,
        data:params,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

// const updateIntrusionType = (body,callback) =>{
//     axios({
//         method: 'put',
//         url: `${getURL('/protocols/update-protocol-message')}`,
//         data:body,
//         validateStatus: (status) => handleResponse(status)
//     }).then((response) => callback(response))
// }

const updateProtocolActions = (body,callback) => {
    //console.log(callback)
    axios({
        method: 'put',
        url: getURL('/protocols/update-protocol-actions'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const updateClientProtocolActions = (body,callback) => {
    axios({
        method: 'put',
        url: getURL('/protocols/update-mapping-protocol-actions'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const setProtocolsInfoMessages = (body,callback) => {
    //console.log(callback)
    axios({
        method: 'put',
        url: getURL('/protocols/update-protocol-message'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const setProtocolsInstructions = (body,callback) => {
    //console.log(callback)
    axios({
        method: 'put',
        url: getURL('/protocols/update-protocol-instructions'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const deleteMessage = (Id, callback) => {
    axios({
        method: 'delete',
        url: getURL('/protocols/delete-intrusion-message'),
        data: Id,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const deleteInstruction = (Id, callback) => {
    axios({
        method: 'delete',
        url: getURL('/protocols/protocol-instructions'),
        data: Id,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const deleteIntrusionType = (body, callback) => {
    axios({
        method: 'delete',
        url: getURL('/protocols/delete-protocol-info'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const deleteProtocolActions  = (body, callback) => { 
    axios({
        method: 'delete',
        url: getURL('/protocols/protocol-actions'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const deleteClientProtocolActions  = (body, callback) => { 
    axios({
        method: 'delete',
        url: getURL('/protocols/protocol-actions-mapping'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}



const UpdateMessage = (body,callback) =>{
    axios({
        method: 'put',
        url: getURL('/protocols/update-message'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const DeleteDeviceMapping = (body,callback) =>{
    axios({
        method: 'delete',
        url: getURL('/protocols/delete-intrusion-message'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const setMultiDevicesProtocol = (body ,callback) => {
    axios({
        method: 'post',
        url: getURL('/protocols/add-introsion-message'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const addUpdateIntrusion = (body ,callback) => {
    axios({
        method: 'put',
        url: getURL('/protocols/add-or-update-protocols-devices'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const addUpdateProtocolActions = (body ,callback) => {
    axios({
        method: 'put',
        url: getURL('/protocols/add-or-update-protocol-actions-mapping'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


export { UpdateMessage, getInrusionInfo, getProtocols, setAddProtocol, getClientInfo, setSaveProtocol, getProtocolsInfo, setProtocolsInfoMessages, deleteMessage, setMultiDevicesProtocol, addInstruction, getInstructionInfo, updateDeviceProtocolsInfo, addIntrusion, deleteInstruction, deleteIntrusionType, addUpdateIntrusion, addUpdateProtocolActions, DeleteDeviceMapping, setProtocolsInstructions, addProtocolActions, getProtocolInfoActions, addClientProtocolActions, getClientProtocolsInfoActions, updateProtocolActions, deleteProtocolActions, updateClientProtocolActions, deleteClientProtocolActions }